import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface DriverState {
	isLoading: boolean;
	allDriverData: any;
	totalDriverCount: number;
	driverDetail: any;
	driverOrderDetail: any;
	LoadingDriver: boolean;
	ratingDetail: any;
	ratingLoading: boolean;
	driverTimeSlot: any;
	totalDriverOrder: number;
	isGeoFenceLoading: boolean;
	DrivergeofenceList: any;
}

const initialState: DriverState = {
	isLoading: false,
	allDriverData: [],
	totalDriverCount: 0,
	driverDetail: {},
	driverOrderDetail: [],
	LoadingDriver: false,
	ratingDetail: {},
	ratingLoading: false,
	driverTimeSlot: [],
	totalDriverOrder: 0,
	isGeoFenceLoading: false,
	DrivergeofenceList: []
};

const driverSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		getAllDriverInit: state => {
			state.isLoading = true;
		},
		getAllDriverSuccess: (state, actions: PayloadAction<any>) => {
			state.isLoading = false;
			const data = actions.payload.data;
			// console.log('data', data);
			state.totalDriverCount = data.driverDetailsCount;
			state.allDriverData = [...data.driverList];
		},
		getAllDriverError: state => {
			state.isLoading = false;
			state.allDriverData = [];
			state.totalDriverCount = 0;
		},
		updateDriverStatusInit: state => {
			state.isLoading = true;
		},
		updateDriverStatusSuccess: state => {
			// state.isLoading = true;
		},
		updateDriverStatusError: state => {
			state.isLoading = false;
		},
		updateDriverAvalibilityInit: state => {
			state.isLoading = true;
		},
		updateDriverAvalibilitySuccess: state => {
			// state.isLoading = true;
		},
		updateDriverAvalibilityError: state => {
			state.isLoading = false;
		},
		updateDriverApprovalRequestInit: state => {
			state.isLoading = true;
		},
		updateDriverApprovalRequestSuccess: state => {
			// state.isLoading = true;
		},
		updateDriverApprovalRequestError: state => {
			state.isLoading = false;
		},
		getDriverDetailByIdInit: state => {
			state.isLoading = true;
			state.driverDetail = {};
		},
		getDriverDetailByIdSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			state.driverDetail = { ...action.payload.data.driverDetails };
		},
		getDriverDetailByIdError: state => {
			state.isLoading = false;
		},
		rejectDriverInit: state => {
			state.isLoading = true;
		},
		rejectDriverSuccess: state => {
			// state.isLoading = true;
		},
		rejectDriverError: state => {
			state.isLoading = false;
		},
		deleteDriverInit: state => {
			state.isLoading = true;
		},
		deleteDriverSuccess: state => {
			// state.isLoading = true;
		},
		deleteDriverError: state => {
			state.isLoading = false;
		},
		getOrderDetailOfDriverInit: state => {
			state.LoadingDriver = true;
			state.driverOrderDetail = [];
			state.totalDriverOrder = 0;
		},
		getOrderDetailOfDriverSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.LoadingDriver = false;
			state.driverOrderDetail = [...data.resonse];
			state.totalDriverOrder = data.count;
		},
		getOrderDetailOfDriverError: state => {
			state.driverOrderDetail = [];
			state.LoadingDriver = false;
			state.totalDriverOrder = 0;
		},
		getDriverRatingInIt: state => {
			state.ratingLoading = true;
			state.ratingDetail = {};
		},
		getDriverRatingSuccess: (state, action: PayloadAction<any>) => {
			state.ratingLoading = false;
			state.ratingDetail = { ...action.payload };
		},
		getDriverRatingError: state => {
			state.ratingLoading = false;
			state.ratingDetail = {};
		},
		getDriverTimeSlotInIt: state => {
			state.isLoading = true;
			state.driverTimeSlot = [];
		},
		getDriverTimeSlotSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.isLoading = false;
			const timedata = data.timeSlotData;
			// console.log('timedata', timedata);
			const Arr: any[] = [];
			timedata?.map((data: any) =>
				data?.timeslot?.map((i: any) => {
					Arr.push({ day: data?.day, timeSlot: { ...i } });
				})
			);

			// console.log(Arr, 'modifiedData');

			state.driverTimeSlot = [...Arr];
		},
		getDriverTimeSlotError: state => {
			state.isLoading = false;
			state.driverTimeSlot = [];
		},
		updateDriverTimeInit: state => {
			state.isLoading = true;
		},
		updateDriverTimeSuccess: state => {
			state.isLoading = false;
		},
		updateDriverTimeError: state => {
			state.isLoading = false;
		},
		updateDriverDetailInit: state => {
			state.isLoading = true;
		},
		updateDriverDetailSuccess: state => {
			state.isLoading = false;
		},
		updateDriverDetailError: state => {
			state.isLoading = false;
		},
		driverGeofenceListInit: state => {
			state.isGeoFenceLoading = true;
			state.DrivergeofenceList = [];
		},
		driverGeofenceListSuccess: (state, action: PayloadAction<any>) => {
			state.isGeoFenceLoading = false;
			state.DrivergeofenceList = [...action.payload.data.geofencesList];
		},
		driverGeofenceListError: state => {
			state.DrivergeofenceList = [];
			state.isGeoFenceLoading = false;
		},
		clearDriverDetail: state => {
			state.driverDetail = {};
		}
	}
});

export const {
	getAllDriverError,
	getAllDriverInit,
	getAllDriverSuccess,
	updateDriverApprovalRequestError,
	updateDriverApprovalRequestInit,
	updateDriverApprovalRequestSuccess,
	updateDriverAvalibilityError,
	updateDriverAvalibilityInit,
	updateDriverAvalibilitySuccess,
	updateDriverStatusError,
	updateDriverStatusInit,
	updateDriverStatusSuccess,
	deleteDriverError,
	deleteDriverInit,
	deleteDriverSuccess,
	getDriverDetailByIdError,
	getDriverDetailByIdInit,
	getDriverDetailByIdSuccess,
	rejectDriverError,
	rejectDriverInit,
	rejectDriverSuccess,
	getOrderDetailOfDriverError,
	getOrderDetailOfDriverInit,
	getOrderDetailOfDriverSuccess,
	getDriverRatingError,
	getDriverRatingInIt,
	getDriverRatingSuccess,
	getDriverTimeSlotError,
	getDriverTimeSlotInIt,
	getDriverTimeSlotSuccess,
	updateDriverTimeError,
	updateDriverTimeInit,
	updateDriverTimeSuccess,
	updateDriverDetailError,
	updateDriverDetailInit,
	updateDriverDetailSuccess,
	driverGeofenceListError,
	driverGeofenceListInit,
	driverGeofenceListSuccess,
	clearDriverDetail
} = driverSlice.actions;
export default driverSlice.reducer;
